<form [formGroup]="registerForm" (ngSubmit)="registerUser()">
    <div class="form-group">
        <label>
            <h5>Име:</h5>
        </label>
        <input type="text" required name="name" class="form-control" placeholder="Иво Георгиев"
            formControlName="name" />
        <div id="input-info" class="text-danger" *ngIf="email.invalid">
            Името е задължително
        </div>

        <label class="pt-4">
            <h5>Email:</h5>
        </label>
        <input type="text" required name="email" class="form-control" placeholder="example@example.com"
            formControlName="email" />
        <div id="input-info" class="text-danger" *ngIf="email.invalid">
            Трябва да въведете валиден email
        </div>

        <label class="pt-4">
            <h5>Парола:</h5>
        </label>
        <input type="password" required name="password" class="form-control" formControlName="password"
            placeholder="********" />
        <div id="input-info" class="text-danger" *ngIf="password.invalid">
            Паролата е задължителна
        </div>

        <label class="pt-4">
            <h5>Повтори паролата:</h5>
        </label>
        <input type="password" required name="password" class="form-control" formControlName="confirmPass"
            placeholder="********" />
        <div id="input-info" class="text-danger" *ngIf="confirmPass.invalid">
            Паролата не съвпада
        </div>

    </div>
    <button class="btn btn-primary" [disabled]="registerForm.invalid" type="submit">Регистрирай ме!</button>
</form>